var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminPanel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5972 121.609H25C25 120.921 25 120.35 25 119.775C25 91.8154 25 63.8559 25 35.8921C25 31.9511 26.909 30.0043 30.835 30.0043C76.9191 30 123.003 30 169.087 30C173.13 30 175 31.9035 175.004 35.9657C175.004 63.9251 175.004 91.8889 175.004 119.848C175.004 120.376 174.961 120.9 174.935 121.514H97.4259C97.4259 119.018 97.482 116.552 97.4129 114.09C97.3308 111.24 97.5554 108.293 96.9248 105.555C94.9208 96.799 89.3838 91.3871 80.573 89.4231C80.262 89.3538 79.9597 89.2543 79.45 89.1116C83.7388 83.8467 85.4146 78.0022 83.8079 71.4222C82.6936 66.8452 80.167 63.1724 76.3792 60.3864C68.8468 54.849 58.4725 55.5801 51.5923 62.0649C45.4722 67.8359 42.4446 79.1702 50.357 88.9818C48.366 89.6783 46.2453 90.1671 44.3579 91.1189C37.1883 94.7268 33.1759 100.58 32.7008 108.648C32.4849 112.308 32.6231 115.985 32.6015 119.658C32.6015 120.242 32.6015 120.826 32.6015 121.605L32.5972 121.609ZM136.111 44.4275C127.219 44.4275 118.326 44.4188 109.433 44.4275C106.526 44.4275 105.446 45.522 105.442 48.4507C105.433 54.6024 105.433 60.7584 105.442 66.9101C105.446 69.8129 106.569 70.9593 109.437 70.9593C127.171 70.968 144.901 70.968 162.635 70.9593C165.593 70.9593 166.703 69.8302 166.712 66.8236C166.725 60.7801 166.72 54.7322 166.712 48.6887C166.712 45.4484 165.692 44.4275 162.466 44.4275C153.681 44.4232 144.896 44.4275 136.111 44.4275ZM136.029 109.487C144.866 109.487 153.707 109.492 162.544 109.487C165.567 109.487 166.699 108.389 166.707 105.434C166.72 99.2822 166.72 93.1262 166.707 86.9745C166.699 84.0414 165.623 82.9599 162.712 82.9599C144.927 82.9512 127.141 82.9512 109.359 82.9599C106.548 82.9599 105.451 84.0717 105.442 86.888C105.429 92.8796 105.438 98.8712 105.442 104.863C105.442 108.549 106.375 109.492 110.003 109.492C118.68 109.492 127.357 109.492 136.034 109.492L136.029 109.487Z",
    fill: "url(#paint0_linear_26_297)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 128.241H174.832C174.832 131.572 175.03 134.847 174.762 138.083C174.581 140.263 172.573 141.704 170.34 141.903C169.752 141.955 169.156 141.929 168.56 141.929C122.852 141.929 77.148 141.929 31.4397 141.929C26.706 141.929 25 140.229 25 135.513C25 133.143 25 130.772 25 128.241ZM99.9957 138.178C99.9957 138.178 99.9957 138.165 99.9957 138.157C101.067 138.157 102.151 138.265 103.205 138.131C104.837 137.927 105.887 136.638 105.917 135.037C105.943 133.42 104.954 131.988 103.334 131.853C101.153 131.672 98.9375 131.676 96.7564 131.841C95.1281 131.966 94.1175 133.381 94.1261 134.986C94.1304 136.647 95.2318 137.958 96.9421 138.152C97.9485 138.269 98.9764 138.174 99.9957 138.174V138.178Z",
    fill: "url(#paint1_linear_26_297)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7484 121.531H39.4685C39.4685 116.522 38.9373 111.516 39.5981 106.676C40.4749 100.282 46.2365 95.7349 52.6934 95.6224C60.7139 95.4883 68.7386 95.4926 76.7634 95.5965C84.1273 95.6916 89.8544 100.576 90.6577 107.878C91.1501 112.338 90.7484 116.894 90.7484 121.531Z",
    fill: "url(#paint2_linear_26_297)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9095 170.995C91.9366 170.995 83.968 170.995 75.9951 170.995C75.4595 170.995 74.8937 171.034 74.3927 170.883C73.3993 170.58 73.1704 169.892 73.7621 169.018C73.9694 168.711 74.2847 168.482 74.5611 168.222C80.1197 163.083 84.1796 156.918 86.9006 149.884C87.3498 148.725 87.894 148.392 89.099 148.405C96.4241 148.465 103.749 148.461 111.07 148.405C112.163 148.396 112.629 148.729 113.026 149.75C115.804 156.884 119.911 163.135 125.539 168.365C126.009 168.802 126.148 169.602 126.437 170.234C125.776 170.489 125.115 170.957 124.455 170.961C116.27 171.013 108.081 170.995 99.8966 170.995H99.9095Z",
    fill: "url(#paint3_linear_26_297)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.908 63.2242C72.1035 63.1983 77.9169 68.9822 77.8824 76.1376C77.8478 83.2453 72.0992 88.9774 64.9987 88.9904C57.9112 89.0077 52.1496 83.254 52.128 76.1462C52.1064 69.0168 57.8118 63.2502 64.9123 63.2242H64.908Z",
    fill: "url(#paint4_linear_26_297)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.065 64.3622H112.081V51.0552H160.065V64.3622ZM130.752 54.4728C128.89 54.4512 127.478 55.8398 127.482 57.6871C127.491 59.4651 128.985 60.9576 130.765 60.9576C132.44 60.9576 133.926 59.4694 133.956 57.7693C133.991 55.9263 132.596 54.4944 130.752 54.4771V54.4728ZM119.794 54.4814C118.049 54.5031 116.65 55.935 116.65 57.6957C116.65 59.4954 118.188 60.9965 119.976 60.9316C121.725 60.8711 123.12 59.4218 123.12 57.6698C123.12 55.8182 121.699 54.4555 119.799 54.4771L119.794 54.4814Z",
    fill: "url(#paint5_linear_26_297)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.028 102.825V89.5615H160.116V102.825H112.028ZM130.63 92.9964C128.873 92.9921 127.495 94.3938 127.486 96.1977C127.477 97.9498 128.89 99.4207 130.617 99.4596C132.414 99.5029 133.96 98.0017 133.956 96.2194C133.956 94.3808 132.526 93.0051 130.63 92.9964ZM119.941 93.0137C118.053 92.9921 116.65 94.3765 116.667 96.241C116.684 97.9887 118.105 99.4293 119.837 99.4596C121.647 99.4899 123.098 98.0277 123.102 96.1718C123.102 94.3721 121.768 93.0354 119.941 93.0137Z",
    fill: "url(#paint6_linear_26_297)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26_297",
    x1: 100.002,
    y1: 30,
    x2: 100.002,
    y2: 121.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26_297",
    x1: 99.9512,
    y1: 128.241,
    x2: 99.9512,
    y2: 141.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26_297",
    x1: 65.0847,
    y1: 95.52,
    x2: 65.0847,
    y2: 121.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26_297",
    x1: 99.9382,
    y1: 148.404,
    x2: 99.9382,
    y2: 171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26_297",
    x1: 65.0052,
    y1: 63.2241,
    x2: 65.0052,
    y2: 88.9904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26_297",
    x1: 136.073,
    y1: 51.0552,
    x2: 136.073,
    y2: 64.3622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26_297",
    x1: 136.072,
    y1: 89.5615,
    x2: 136.072,
    y2: 102.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 141,
    fill: "white",
    transform: "translate(25 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminPanel);
export default __webpack_public_path__ + "static/media/Admin_Panel.9ffed4de166e2afdcd81616e181a9185.svg";
export { ForwardRef as ReactComponent };